const middleware = {}

middleware['abTestForLoggedInUsers'] = require('../middleware/abTestForLoggedInUsers.ts')
middleware['abTestForLoggedInUsers'] = middleware['abTestForLoggedInUsers'].default || middleware['abTestForLoggedInUsers']

middleware['aBTestSetFromQuery'] = require('../middleware/aBTestSetFromQuery.ts')
middleware['aBTestSetFromQuery'] = middleware['aBTestSetFromQuery'].default || middleware['aBTestSetFromQuery']

middleware['auth_admin'] = require('../middleware/auth_admin.ts')
middleware['auth_admin'] = middleware['auth_admin'].default || middleware['auth_admin']

middleware['auth_user'] = require('../middleware/auth_user.ts')
middleware['auth_user'] = middleware['auth_user'].default || middleware['auth_user']

middleware['get_user_ip'] = require('../middleware/get_user_ip.ts')
middleware['get_user_ip'] = middleware['get_user_ip'].default || middleware['get_user_ip']

middleware['log_page_views'] = require('../middleware/log_page_views.ts')
middleware['log_page_views'] = middleware['log_page_views'].default || middleware['log_page_views']

middleware['marking'] = require('../middleware/marking.ts')
middleware['marking'] = middleware['marking'].default || middleware['marking']

middleware['promo_setter'] = require('../middleware/promo_setter.ts')
middleware['promo_setter'] = middleware['promo_setter'].default || middleware['promo_setter']

middleware['redirect_rules/index'] = require('../middleware/redirect_rules/index.ts')
middleware['redirect_rules/index'] = middleware['redirect_rules/index'].default || middleware['redirect_rules/index']

middleware['set_after_signup_path'] = require('../middleware/set_after_signup_path.ts')
middleware['set_after_signup_path'] = middleware['set_after_signup_path'].default || middleware['set_after_signup_path']

middleware['setJobTitleAfterSignUp'] = require('../middleware/setJobTitleAfterSignUp.ts')
middleware['setJobTitleAfterSignUp'] = middleware['setJobTitleAfterSignUp'].default || middleware['setJobTitleAfterSignUp']

middleware['signup_modal'] = require('../middleware/signup_modal.ts')
middleware['signup_modal'] = middleware['signup_modal'].default || middleware['signup_modal']

export default middleware
